if (!customElements.get('collection-hero-slider')) {
  customElements.define(
    'collection-hero-slider',
    class CollectionHeroSlider extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.intervalId = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.slides = [];
        this.dots = [];
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));

        if (this.slides.length < 2) return;

        this.interval = Number(this.dataset.interval) || 6000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.nextButton = this.querySelector('[data-hero-next]');
        this.previousButton = this.querySelector('[data-hero-prev]');

        this.nextButton?.addEventListener('click', this.showNext.bind(this));
        this.previousButton?.addEventListener('click', this.showPrevious.bind(this));
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index, true));
        });

        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
        this.addEventListener('focusin', this.stopAutoplay.bind(this));
        this.addEventListener('focusout', this.startAutoplay.bind(this));

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      startAutoplay() {
        if (!this.autoplay || this.reducedMotion.matches || this.slides.length < 2) return;

        this.stopAutoplay();
        this.intervalId = window.setInterval(() => this.showNext(), this.interval);
      }

      stopAutoplay() {
        if (!this.intervalId) return;

        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }

      showNext() {
        this.goToSlide((this.currentIndex + 1) % this.slides.length, true);
      }

      showPrevious() {
        this.goToSlide((this.currentIndex - 1 + this.slides.length) % this.slides.length, true);
      }

      goToSlide(index, resetAutoplay = false) {
        if (index === this.currentIndex || !this.slides[index]) return;

        this.slides[this.currentIndex].classList.remove('is-active');
        this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');
        this.dots[this.currentIndex]?.classList.remove('is-active');
        this.dots[this.currentIndex]?.setAttribute('aria-current', 'false');

        this.currentIndex = index;

        this.slides[this.currentIndex].classList.add('is-active');
        this.slides[this.currentIndex].setAttribute('aria-hidden', 'false');
        this.dots[this.currentIndex]?.classList.add('is-active');
        this.dots[this.currentIndex]?.setAttribute('aria-current', 'true');

        if (resetAutoplay) this.startAutoplay();
      }
    }
  );
}
